import NeighborhoodPage from "@/components/NeighborhoodPage";

const CentroDoRio = () => (
  <NeighborhoodPage
    name="Centro do Rio"
    slug="centro-do-rio"
    description="O coração financeiro e histórico do Rio de Janeiro. Imóveis comerciais e residenciais no Centro, com forte potencial de valorização e retrofit em prédios icônicos."
  />
);

export default CentroDoRio;
